<template>
    <div class="password-field">
        <div class="password-control">
            <input
                :id="id"
                v-model="password"
                :type="passwordFieldType"
                class="form-control"
                :class="inputClass"
                :name="name"
                :data-test-id="dataTestId"
                :autocomplete="autocomplete"
                :required="required" />
            <button type="button" class="password-toggle" :aria-label="toggleLabel" :title="toggleLabel" @click="switchVisibility">
                <feather class="feather-18" :type="featherIcon" />
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "CurrentPasswordInputComponent",
    data() {
        return {
            passwordFieldType: "password",
            featherIcon: "eye",
        };
    },
    props: {
        id: {
            type: String,
            default: undefined,
        },
        value: {
            default: null,
        },
        name: {
            type: String,
            default: undefined,
        },
        dataTestId: {
            type: String,
            default: undefined,
        },
        autocomplete: {
            type: String,
            default: "current-password",
        },
        required: {
            type: Boolean,
            default: false,
        },
        inputClass: {
            type: [String, Object, Array],
            default: "",
        },
    },
    computed: {
        toggleLabel() {
            return this.passwordFieldType === "password" ? this.$t("labels.password.show") : this.$t("labels.password.hide");
        },
        password: {
            get() {
                return this.value;
            },
            set(newVal) {
                this.$emit("input", newVal);
            },
        },
    },
    methods: {
        switchVisibility() {
            this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
            this.featherIcon = this.featherIcon === "eye" ? "eye-off" : "eye";
        },
    },
};
</script>

<style lang="scss" scoped>
.password-field {
    position: relative;
    width: 100%;
}

.password-control {
    position: relative;
}

.password-control .form-control {
    padding-right: 50px;
}

.password-control .form-control.is-invalid {
    padding-right: 86px;
    background-position: right 48px center;
}

.password-toggle {
    position: absolute;
    top: 50%;
    right: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    padding: 0;
    color: #083e60;
    background: transparent;
    border: 0;
    border-radius: 8px;
    cursor: pointer;
    transform: translateY(-50%);
    transition: color 0.18s ease, background-color 0.18s ease;
}

.password-toggle:hover,
.password-toggle:focus {
    color: #052a43;
    background-color: rgba(8, 62, 96, 0.08);
    outline: none;
}
</style>
